
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic16Off as ObiHydraulic16OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-16-off.js';
 
 
 

 
 export const ObiHydraulic16Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-16-off',
   elementClass: ObiHydraulic16OffElement,
   events: {
     
   }
  });
 
 